var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var WISHLIST = null;
var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  gridEmpty: '[grid-wishlist-empty]',
  counter: '[counter-wishlist]',
  headerNotice: '[header-notice]',
  headerWishlistPopover: '.header-wishlist-popover'
};

var counters = document.querySelectorAll(selectors.counter);
var headerNotices = document.querySelectorAll(selectors.headerNotice);
var gridEmpty = document.querySelector(selectors.gridEmpty);

window.onload = function () {
  WISHLIST = getWishlist();

  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);

  updateCounter(WISHLIST.length);
};

document.addEventListener('click', function (e) {
  if (e.target.matches(selectors.button) || e.target.closest(selectors.button)) {
    buttonHandler(e);
  }
}, false);

document.addEventListener('wishlist:toggleButtonState', function (e) {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
}, false);

var getSearchQueryString = function (items) {
  return items.map(function (item) {
    return 'id:' + item;
  }).join(' OR ');
};

var setupGrid = function (grid) {
  console.log("SETTING UP GRID");
  var queryString = getSearchQueryString(WISHLIST);

  fetch(window.theme.routes.searchUrl + '?view=wishlist&type=product&q=' + queryString).then(function (res) {
    res.text().then(function (wishlistProductCards) {
      grid.innerHTML = wishlistProductCards;
      var buttons = grid.querySelectorAll(selectors.button) || [];
      if (buttons.length) {
        setupButtons(buttons);
      } else {
        gridEmpty.style.display = 'block';
      }
      if (typeof window.initializeQuickAdd === 'function') {
        window.initializeQuickAdd();
      }
    });
  });
};

var buttonHandler = function (e) {
  e.preventDefault();
  var button = e.target.closest(selectors.button);
  var productId = button.dataset.productId || false;
  if (!productId) return console.error('[Wishlist] Missing `data-product-id` attribute. Failed to update the wishlist.');
  updateWishlist(productId);
  var matching_buttons = document.querySelectorAll(selectors.button + '[data-product-id="' + productId + '"]');
  for (var i = 0; i < matching_buttons.length; i++) {
    matching_buttons[i].classList.toggle(BUTTON_ACTIVE_CLASS);
    if (matching_buttons[i].classList.contains(BUTTON_ACTIVE_CLASS)) {
      setActiveSvg(matching_buttons[i]);
    } else {
      setInactiveSvg(matching_buttons[i]);
    }
  }
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productId = button.dataset.productId || false;
    if (!productId) return console.error('[Wishlist] Missing `data-product-id` attribute. Failed to update the wishlist.');
    if (wishlistContains(productId)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
      setActiveSvg(button);
    } else {
      setInactiveSvg(button);
    }
    button.style.visibility = 'visible';
  });
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  WISHLIST = array;
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

var updateCounter = function (count) {
  if (!counters.length) return;

  counters.forEach(function(counter) {
    if (count > 0) {
      counter.innerHTML = count;
      counter.parentNode.classList.add('is-visible');
    } else {
      counter.innerHTML = '';
      counter.parentNode.classList.remove('is-visible');
    }
  });
};

var updateWishlist = function (id) {
  var wishlist = WISHLIST;
  var indexInWishlist = wishlist.indexOf(id);
  if (indexInWishlist === -1) {
    wishlist.push(id);
  } else {
    wishlist.splice(indexInWishlist, 1);
  }
  updateCounter(wishlist.length);
  if (headerNotices.length) {
    headerNotices.forEach(function(headerNotice) {
      headerNotice.innerHTML = indexInWishlist === -1 ? window.languages.wishlistItemAdded : window.languages.wishlistItemRemoved;
      var popover = headerNotice.closest(selectors.headerWishlistPopover);
      if (popover) {
        popover.classList.add('is-visible');
        setTimeout(function () {
          popover.classList.remove('is-visible');
        }, 2000);
      }
    });
  }

  var grid = document.querySelector(selectors.grid) || false;
  setWishlist(wishlist);
  if (grid) {
    setupGrid(grid);
  }
};

var wishlistContains = function (id) {
  return WISHLIST.indexOf(id) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

var activeSvgContent = `
  <svg class="wishlist-icon" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M 8.7273 14.9767 Z M 12.8916 0.0073 C 11.2895 0.0073 9.6582 0.7651 8.7273 2.3622 C 7.7927 0.7578 6.1658 0 4.568 0 C 2.2531 0 0 1.5905 0 4.5026 C 0 7.8924 4.0516 11.36 8.7273 16 C 13.4036 11.36 17.4545 7.8924 17.4545 4.5026 C 17.4545 1.5855 15.2036 0.0073 12.8916 0.0073 Z" fill="#212121"/>
  </svg>
`;

var inactiveSvgContent = `
  <svg class="wishlist-icon" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.72727 14.9767C4.63273 10.9484 0.727273 7.488 0.727273 4.50255C0.727273 1.74545 2.95855 0.727273 4.568 0.727273C5.52218 0.727273 7.58691 1.09164 8.72727 3.96873C9.88364 1.08291 11.9738 0.734545 12.8916 0.734545C14.7389 0.734545 16.7273 1.91345 16.7273 4.50255C16.7273 7.46182 12.992 10.7753 8.72727 14.9767ZM12.8916 0.00727272C11.2895 0.00727272 9.65818 0.765091 8.72727 2.36218C7.79273 0.757818 6.16582 0 4.568 0C2.25309 0 0 1.59055 0 4.50255C0 7.89236 4.05164 11.36 8.72727 16C13.4036 11.36 17.4545 7.89236 17.4545 4.50255C17.4545 1.58545 15.2036 0.00727272 12.8916 0.00727272Z" fill="#212121"/>
  </svg>
`;

var setActiveSvg = function (button) {
  button.innerHTML = activeSvgContent;
};

var setInactiveSvg = function (button) {
  button.innerHTML = inactiveSvgContent;
};
